// PageVariablesEmpresas.js

export const pageVariables = {
    
    headers: [
       'NOME', 'IDADE','STATUS', 'DATA DE CONTATO', 'DATA RETORNO', 'DATA DE VISITA', 'AGENDAMENTO', 'AGENDADOR', 'CONSULTOR', 'STATUS DO CONTATO', 'STATUS COMERCIAL'
    ],
    headerInfo: {
        title: "Rotas Geradas",
        description: "Gerencie os agendamentos e verifique o status de cada visita planejada. Acompanhe os responsáveis, os segurados associados e mantenha o controle sobre os eventos agendados de maneira organizada e eficiente."
    },    
    inputs: [
    
        {
            name: "observacao",
            type: "select",
            label: "Obeservações",
        }
        
    ],
    consultores: [
    ],
    consultoresPage: process.env.VUE_APP_API_URL+"get-group-members/consultores",
    page: process.env.VUE_APP_API_URL+"listas",
    pageBadge: process.env.VUE_APP_API_URL+"badge",
    getPageLista: process.env.VUE_APP_API_URL+"getListas",
    listaViewPage: process.env.VUE_APP_API_URL+"lista",
    statusRegrasPage: process.env.VUE_APP_API_URL+"agendamentos/status-regras",
};
